<template>
    <el-form :model="formData" :rules="rules" ref="stepForm">
        <el-row :gutter="15">
            <el-col :span="24" class="form-step-title">
                <div class="steptitle">
                    {{ stepTitle }}
                </div>
                <el-checkbox
                    v-if="formData['sameAsApplicant'] !== undefined"
                    v-model="formData['sameAsApplicant']"
                    >Same as applicant details
                </el-checkbox>
                <div v-else>&nbsp;</div>
            </el-col>
            <el-col v-for="(val, field, j) in value" :key="'validation_g' + j">
                <el-form-item :prop="field" v-if="field == 'gender'">
                    <div style="width: 100%">
                        <el-radio
                            type="radio"
                            id="male"
                            v-model="formData[field]"
                            label="mr"
                            >Mr.</el-radio
                        >
                        <el-radio
                            type="radio"
                            v-model="formData[field]"
                            label="mrs"
                            >Mrs.</el-radio
                        >
                        <el-radio
                            type="radio"
                            v-model="formData[field]"
                            label="ms"
                            >Ms.</el-radio
                        >
                    </div>
                </el-form-item>
            </el-col>
            <el-col
                :sm="24"
                :md="12"
                v-for="(val, field, i) in value"
                :key="'validation' + i"
            >
                <el-form-item :prop="field" v-if="field == 'applying_as'">
                    <label class="el-form--label-top"
                        >{{ __("fieldnames." + formName + "." + field) }}*
                    </label>
                    <div style="width: 100%">
                        <el-radio v-model="formData[field]" label="designer"
                            >Designer</el-radio
                        >
                        <el-radio v-model="formData[field]" label="manufacturer"
                            >Manufacturer</el-radio
                        >
                        <el-radio v-model="formData[field]" label="pr_agency"
                            >PR Agency</el-radio
                        >
                        <el-radio v-model="formData[field]" label="other"
                            >Other</el-radio
                        >
                    </div>
                </el-form-item>
                <div v-else-if="field == 'sameAsApplicant'"></div>
                <el-form-item :prop="field" v-else-if="field == 'newsletter'">
                    <label class="el-form--label-top"
                        >{{ __("fieldnames." + formName + "." + field) }}*
                    </label>
                    <div style="width: 100%">
                        <el-radio v-model="formData[field]" :label="1"
                            >Yes</el-radio
                        >
                        <el-radio v-model="formData[field]" :label="0"
                            >No</el-radio
                        >
                    </div>
                </el-form-item>
                <el-form-item :prop="field" v-else-if="field == 'country'">
                    <InputWh
                        :placeholder="field"
                        :options="countryOptions"
                        fieldType="select"
                        :required="rules[field][0].required"
                        :disabled="isSame"
                        :formName="formName"
                        :formStep="step"
                        v-model="formData[field]"
                        @change="formData.state_region = ''"
                    ></InputWh>
                </el-form-item>
                <template v-else-if="field == 'state_region'">
                    <el-form-item
                        :prop="field"
                        v-if="
                            currentStateOptions != {} &&
                            currentStateOptions.length != 0
                        "
                    >
                        <InputWh
                            :placeholder="field"
                            :options="currentStateOptions"
                            fieldType="select"
                            :required="rules[field][0].required"
                            :disabled="isSame"
                            :formName="formName"
                            :formStep="step"
                            v-model="formData[field]"
                        ></InputWh>
                    </el-form-item>
                    <div class="emptyfield" v-else>&nbsp;</div>
                </template>
                <el-form-item :prop="field" v-else-if="field == 'category'">
                    <InputWh
                        :placeholder="field"
                        :options="categoryOptions"
                        fieldType="select"
                        :required="rules[field][0].required"
                        :formName="formName"
                        :formStep="step"
                        v-model="formData[field]"
                    ></InputWh>
                </el-form-item>
                <el-form-item
                    :prop="field"
                    v-else-if="field == 'year_of_production'"
                >
                    <InputWh
                        :placeholder="field"
                        :options="yearOptions"
                        fieldType="select"
                        :required="rules[field][0].required"
                        :formName="formName"
                        :formStep="step"
                        v-model="formData[field]"
                    ></InputWh>
                </el-form-item>
                <el-form-item
                    v-if="
                        field != 'gender' &&
                        field != 'newsletter' &&
                        field != 'applying_as' &&
                        field != 'project_description' &&
                        field != 'dropbox_link' &&
                        field != 'video_link' &&
                        field != 'year_of_production' &&
                        field != 'category' &&
                        field != 'subcategory' &&
                        field != 'state_region' &&
                        field != 'country' &&
                        field != 'sameAsApplicant'
                    "
                    :prop="field"
                >
                    <InputWh
                        :placeholder="field"
                        v-model="formData[field]"
                        :disabled="field != 'vat_id' ? isSame : false"
                        :formName="formName"
                        :formStep="step"
                        :required="rules[field][0].required"
                    ></InputWh>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="15">
            <el-col v-for="(val, field, j) in value" :key="'validation_pd' + j">
                <el-form-item
                    :prop="field"
                    v-if="field == 'project_description'"
                >
                    <div class="projectdesc">
                        <div class="field-heading">
                            Project Description (1000 words max)*
                        </div>
                        <el-form-item :prop="field">
                            <InputWh
                                :placeholder="field"
                                fieldType="textarea"
                                :required="rules[field][0].required"
                                :formName="formName"
                                :formStep="step"
                                v-model="formData[field]"
                            ></InputWh>
                            <span class="message-counter"
                                >{{ formData[field].length }} /
                                <span
                                    v-bind:style="[
                                        formData[field].length < 5000
                                            ? { color: 'green' }
                                            : { color: 'red' },
                                    ]"
                                    >5000</span
                                >
                                max characters</span
                            >
                        </el-form-item>
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
        <div class="form-buttons">
            <el-button
                @click="$emit('prevStep')"
                type="text"
                size="medium"
                icon="el-icon-arrow-left"
                v-if="step > 0"
            >
                Back
            </el-button>
            <div v-else>&nbsp;</div>
            <el-button @click="handleNextStep()">Next</el-button>
        </div>
    </el-form>
</template>

<script>
import InputWh from "@/core/components/InputWithHint";

export default {
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        applicant: Object,
        stepTitle: String,
        step: Number,
    },
    components: {
        InputWh,
    },
    computed: {
        yearOptions: function () {
            let currentYear = new Date().getFullYear() - 3;
            let yearOptions = {};
            for (let year = currentYear; year <= currentYear + 3; year++) {
                yearOptions[year] = year;
            }
            return yearOptions;
        },
        isSame: function () {
            if (this.formData.sameAsApplicant) {
                return true;
            }
            return false;
        },
        formData: {
            get() {
                return this.value;
            },
            set(newVal) {},
        },
    },
    methods: {
        handleNextStep() {
            let self = this;
            this.$refs.stepForm.validate((valid) => {
                if (valid) {
                    self.$emit("nextStep");
                } else {
                    alert(
                        "Please correct the form errors before proceeding to the next step."
                    );
                }
            });
        },
        copyApplicantDetails: function () {
            if (this.formData.sameAsApplicant !== undefined) {
                if (this.formData.sameAsApplicant == 1) {
                    let step1values = Object.assign({}, this.applicant);
                    Object.keys(step1values).forEach((key) => {
                        if (this.formData[key] !== undefined) {
                            this.formData[key] = step1values[key];
                        }
                    });
                } else {
                    /*Object.keys(this.formData).forEach(key => {
                        this.formData[key] = '';
                    });*/
                }
            }
        },
    },
    watch: {
        "formData.country": function (newVal, oldVal) {
            let self = this;
            if (self.formData.state_region !== undefined) {
                if (newVal && self.stateOptions[newVal]) {
                    self.currentStateOptions = self.stateOptions[newVal];
                }
            }
        },
        step: function (newVal, oldVal) {
            this.copyApplicantDetails();
        },
        "formData.sameAsApplicant": function (newVal, oldVal) {
            this.copyApplicantDetails();
        },
    },
    data: () => ({
        rules: {
            firstname: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            lastname: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            company_name: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            job_title: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            phone_number: [
                {
                    required: true,
                    pattern: /^[0-9._\+\-\(\) ]+$/i,
                    message: "This field is invalid",
                    trigger: "blur",
                },
            ],
            fax: [
                {
                    required: false,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            email: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
                {
                    type: "email",
                    message: "This field is invalid",
                    trigger: "blur",
                },
            ],
            web_address: [
                {
                    required: true,
                    message: "This is not a valid website",
                    trigger: "blur",
                },
            ],
            address1: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            address2: [
                {
                    required: false,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            country: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            state_region: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            city: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            postcode: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            applying_as: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            gender: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            newsletter: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            vat_id: [
                {
                    required: true,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
            sameAsApplicant: [
                {
                    required: false,
                    message: "This field is required",
                    trigger: "blur",
                },
            ],
        },
        formName: "testd",
        countryOptions: window._countries,
        stateOptions: window._states,
        currentStateOptions: [],
        categoryOptions: {
            "Bath and Accessories": "Bath and Accessories",
            "Building/Architectural Materials":
                "Building/Architectural Materials",
            "Children's Products": "Children's Products",
            Electronics: "Electronics",
            "Environments/Architecture": "Environments/Architecture",
            "Floor and Wall Covering": "Floor and Wall Covering",
            Furniture: "Furniture",
            "Graphic Design": "Graphic Design",
            Hardware: "Hardware",
            Household: "Household",
            Industrial: "Industrial",
            Installation: "Installation",
            "Interactive Media": "Interactive Media",
            "Kitchen and Appliances": "Kitchen and Appliances",
            Lighting: "Lighting",
            Medical: "Medical",
            "Mobile Application": "Mobile Application",
            Multimedia: "Multimedia",
            "Office Products": "Office Products",
            Packaging: "Packaging",
            Personal: "Personal",
            "Personal Experience": "Personal Experience",
            "Pet Products": "Pet Products",
            Recycling: "Recycling",
            "Retail Fittings": "Retail Fittings",
            Robotics: "Robotics",
            "Safety and Security": "Safety and Security",
            "Sports and Recreation": "Sports and Recreation",
            Tabletop: "Tabletop",
            Textiles: "Textiles",
            Tools: "Tools",
            Transportation: "Transportation",
        },
        filesError: "",
    }),
};
</script>
